<template>
  <div class="wrap home">
    <Welcome v-if="$route.name == 'Home'" msg="Welcome To Normcore." />
    <div class="applications">
	    <div class="create-new">
    		<h3>+ Create a new application</h3>
    	</div>
    	<TileButton title= "NormcoreTestApp" planName="Prototype"/>
    	<TileButton title= "Beat Saber 2" planName="Pro"/>
    	<TileButton title= "Sportsball" planName="Ultimate"/>

    </div>
  <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Welcome from "@/components/Welcome.vue";
import Footer from "@/components/Footer.vue";
import TileButton from "@/components/TileButton.vue";






export default {
  name: "Applications",
  props: {
    user: {
      type: Object,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return {  }
      }
    },
  },
  components: {
    Welcome,
    Footer,
    TileButton
  },
  created() {
  	  //update app.vue with a fake user for now
      this.$emit('updateUser', {id:1});
  }
};
</script>


<style scoped lang="scss">
.tile-grid {
	// display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin: -10px; 
}

.tile:nth-child(4) {
	background-image: url("/img/normcoreElements.jpg");
	background-position-y: 142%;
	// background-color: red;
	// background-color: red;

}
.tile:nth-child(2) {
	background-color: #EEE;
	color: black;
}
.applications {
	// display: flex;
	margin-top: 30px;
}
.create-new {
	padding: 20px 40px;
    text-align: left;
    display: inline-block;
    cursor: pointer;
}


</style>



